import GHGeometry from './GHGeometry';
import EMFMesh from './EMFMesh';
import MaterialTypes from '../../MaterialTypes';

const scale = 0.002;

export default class GHMesh extends EMFMesh {
  constructor (solidObject = null, ghgeom = null, material = null) {
    let geom = null;
    if (ghgeom == null) {
      geom = new GHGeometry();
    } else {
      geom = ghgeom;
    }
    super(geom, material);

    if (solidObject !== null) {
      this.solidObject = solidObject;
    }
  }

  update (manager) {
    this.geometry.dispose();

    let dataTree = this.solidObject.value;
    this.geometry = new GHGeometry();

    let materialId = 0;
    let paintId = null;
    for (let i = 0; i < dataTree.branches.length; i++) {
      for (let j = 0; j < dataTree.branches[i].length; j++) {
        const geom = dataTree.branches[i][j];
        materialId = Math.max(0, geom.materialId);
        if (geom.paintId !== null) {
          paintId = geom.paintId;
        }
        this.geometry.merge(geom);
        this.geometry.selectable = geom.selectable;
        this.geometry.visible = geom.visible;
        this.geometry.component = geom.component;
        this.geometry.index = geom.index;
      }
    }
    this.geometry.computeFaceNormals();

    const { material, paint } = manager;
    if (material !== undefined) {
      const mat = material.use(materialId);
      this.materials[MaterialTypes.NORMAL] = mat.clone(); // Override normal material
    }
    if (paint !== undefined) {
      const color = paint.use(paintId);
      this.materials[MaterialTypes.NORMAL].color = new THREE.Color(color); // apply color
    }
    this.materials[MaterialTypes.NORMAL].needsUpdate = true;

    this.computeUvs();
  }

  setTextures (pack) {
    // through
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/GHMesh.js